import { ReactNode } from "react"
import {
  HeadingXSmall,
  ModalBody,
  ParagraphMedium,
  Spinner,
  useStyletron,
} from "@mezo-org/mezo-clay"

type WaitingForActionModalBodyProps = {
  title: ReactNode
  description?: string
}

export default function WaitingForActionModalBody({
  title,
  description,
}: WaitingForActionModalBodyProps) {
  const [css, theme] = useStyletron()

  return (
    <ModalBody
      className={css({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "140px",
        height: "100%",
        textAlign: "center",
      })}
    >
      <Spinner $size="xlarge" />
      <HeadingXSmall marginTop={theme.sizing.scale800}>{title}</HeadingXSmall>
      {description && (
        <ParagraphMedium
          color={theme.colors.contentSecondary}
          marginTop={theme.sizing.scale300}
        >
          {description}
        </ParagraphMedium>
      )}
    </ModalBody>
  )
}
